module.exports = __webpack_public_path__ + "static/media/Conthrax.77e2c172.ttf";